export const INSPECTIONS_HEADER_HEIGHT = 265;

export const COLLAPSE_ELEMENT_OFFSET_TOP = INSPECTIONS_HEADER_HEIGHT + 20;
